import "./namespace.js";
import "#/legacy/namespaces.js";

// The value an `sp-finder-filter` change submits under its param. A `single` list filter emits a
// one-id array and submits the id alone: `["female"]` → `"female"`.
DoctorFinder.Helpers.FilterAppValue = {
  submitted(element, value) {
    const isSingle = element.matches('[single]:not([single="false"])');

    return isSingle && Array.isArray(value) ? value[0] : value;
  },
};
